module.exports = __webpack_public_path__ + "4e0adb61f71a0ad81b1542634347b368.svg";